import { useLang } from "../../context/LanguageContext";
import { useSite } from "../../context/SiteContext";
import { MapPin, Phone, Mail, Facebook, Instagram } from "lucide-react";

export default function Footer() {
  const { t } = useLang();
  const { site } = useSite();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A2B4C] text-white pt-12 sm:pt-20 pb-8 sm:pb-10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-4 gap-8 sm:gap-12 mb-10 sm:mb-16">
        <div className="md:col-span-2">
          <h3 className="font-serif text-2xl sm:text-3xl mb-3">
            Sithonia <span className="italic font-light">Holidays</span>
          </h3>
          <p className="text-white/70 max-w-sm leading-relaxed text-sm sm:text-base">{t.footer.tagline}</p>
        </div>

        <div>
          <p className="uppercase text-xs tracking-widest text-white/50 mb-4">
            {t.footer.quickLinks}
          </p>
          <ul className="space-y-2 text-white/85 text-sm">
            <li><a href="#apartments" className="hover:text-white">{t.nav.apartments}</a></li>
            <li><a href="#gallery" className="hover:text-white">{t.nav.gallery}</a></li>
            <li><a href="#location" className="hover:text-white">{t.nav.location}</a></li>
            <li><a href="#booking" className="hover:text-white">{t.nav.booking}</a></li>
            <li><a href="#contact" className="hover:text-white">{t.nav.contact}</a></li>
          </ul>
        </div>

        <div>
          <p className="uppercase text-xs tracking-widest text-white/50 mb-4">
            {t.footer.contact}
          </p>
          <ul className="space-y-3 text-white/85 text-sm">
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-0.5 text-[#A2D2FF]" />
              <span>{site.address}</span>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-[#A2D2FF]" />
              <a href={`tel:${site.phone}`}>{site.phone_display}</a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-[#A2D2FF]" />
              <a href={`mailto:${site.email}`}>{site.email}</a>
            </li>
            {(site.facebook_url || site.instagram_url) && (
              <li className="flex items-center gap-3 pt-2">
                {site.facebook_url && (
                  <a href={site.facebook_url} target="_blank" rel="noreferrer" aria-label="Facebook">
                    <Facebook className="w-5 h-5 text-[#A2D2FF] hover:text-white" />
                  </a>
                )}
                {site.instagram_url && (
                  <a href={site.instagram_url} target="_blank" rel="noreferrer" aria-label="Instagram">
                    <Instagram className="w-5 h-5 text-[#A2D2FF] hover:text-white" />
                  </a>
                )}
              </li>
            )}
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 border-t border-white/10 pt-6 sm:pt-8 flex flex-col md:flex-row items-center justify-between gap-3 sm:gap-4 text-[11px] sm:text-xs text-white/50 text-center md:text-left">
        <span>© {year} Sithonia Holidays. {t.footer.rights}</span>
        <span>Nikiti · Sithonia · Halkidiki · Greece</span>
      </div>
    </footer>
  );
}
